import moment from 'moment';
import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { AiFillHeart, AiOutlineHeart } from 'react-icons/ai';
import { BiTransfer } from 'react-icons/bi';
import { IoIosMail } from 'react-icons/io';
import { MdLocationOn, MdWifiCalling3 } from 'react-icons/md';
// import { RiHotelFill } from 'react-icons/ri';
import parser from 'html-react-parser';
import { FaCrown } from 'react-icons/fa';
import { TbCalendarTime } from 'react-icons/tb';
import { TiStarFullOutline } from 'react-icons/ti';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { restrictOnlyUserActions } from '../../Helper/restrictActions';
import image from '../../assets/images/house.jpg';
import { imageUrl } from '../../config/apiUrl';
import { Area, building } from '../../constant/imagePath';
import { useFavoriteEntityMutation, usePostApiMutation } from '../../store/apiSlice/apiSlice';
import { updateUser } from '../../store/auth/authSlice';
import { usdToOther2 } from '../../utils/helpers';
import ElasticCarousel from '../ElasticCarousel';
import Tooltip from '../Tooltip';
import classes from './ProjectCard.module.css';
const items = [image, image];



/*eslint-disable*/
const ProjectCard = ({
  type,
  data = {
    map: false,
    _id: 12,
    images: items,
    title: 'ABCDEF',
    priceRange: '200-300',
    startPrice: '2000',
    endPrice: '4000',
    description: 'Full floor for sale I All unit already',
    location: '2415 Byron Shire, New South - Wales',
    type: 'Apartment',
    noOfUnits: '5',
    // propertyArea:"700",
    // noOfBedroooms:"5",
    // noOfBathrooms:"2",
    // eventType:"abcd",
    deliveryDate: moment().format('MMM Do YY')
  },
  imageClass,
  onEmailClick = () => null,
  refetch
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('webCommon');
  const { selectedLanguage } = useSelector((state) => state.languageReducer);
  const { currency } = useSelector((state) => state.converterReducer);
  const { user, isLogin } = useSelector((state) => state.authReducer);
  const [compared, setCompared] = useState(false);
  const navigate = useNavigate();
  const [onFavorite, { isLoading: isFavoriting }] = useFavoriteEntityMutation();
  const [postApiFunc] = usePostApiMutation();

  const phoneNumber =
    data?.assignedAgent?.phoneNumber ?? data?.agent?.phoneNumber ?? data?.company?.phoneNumber;

  const feature = data?.isPremium || data?.isFeatured;

  const isFavorite = data?.favoriteBy?.includes(user?._id);
  const handleCompare = async (data) => {
    const onlyCompareProperty = user?.compareList?.filter((item) => item?.type == 'Project');
    const ifAlreadyExist = onlyCompareProperty?.find((item) => item?.entity == data?._id);
    if (!ifAlreadyExist && onlyCompareProperty?.length >= 3)
      return toast.error(t('projectCard.toast.error'));

    const response = await postApiFunc({
      url: `users/compare/add`,
      method: 'POST',
      tag: `compareListFront`,
      data: {
        id: data?._id,
        type: 'project'
      }
    });
    if (response?.data) {
      dispatch(updateUser(response?.data?.data));
      toast.success(
        `${t('projectCard.project')} ${
          ifAlreadyExist ? t('projectCard.toast.removedFrom') : t('projectCard.toast.addedIn')
        } ${t('projectCard.toast.success')}`
      );
    }
  };

  const handleFavorite = async () => {
    if (isFavoriting) return;
    const res = await onFavorite({ id: data?._id, type: 'project' });
    refetch && refetch();
    if (res?.data) {
      if (res?.data?.data) {
        toast.success(t('projectCard.toast.removeFromFavList'));
      } else {
        toast.success(t('projectCard.toast.addInFavList'));
      }
    }
  };

  const handleAction = () => {
    const isAllowedActions = restrictOnlyUserActions(user?.role);
    if (!isLogin) {
      navigate('/login');
    } else if (isAllowedActions) {
      return true;
    }
  };

  return (
    <>
      <style>
        {`
 
                    a {
          text-decoration: none;
          color: inherit;
        }
          a:hover {
            text-decoration: none;
            color: inherit;
          }
      `}
      </style>

      <div className={type === 'map' ? classes.cardMainMap : classes.cardMain}>
        <div className={type !== 'map' && classes.paddingDiv}>
          <div className={[classes.image, imageClass].join(' ')}>
            {/* Tag */}
            {(data?.isPremium || data?.isFeatured) && (
              <div className={classes?.featuredPremiumContainer}>
                <span
                  className={`${
                    (data?.isFeatured && classes?.featuredIco) ||
                    (data?.isPremium && classes?.premiumIco)
                  }`}>
                  {data?.isFeatured && <TiStarFullOutline size={16} />}
                  {data?.isPremium && <FaCrown size={14} />}
                  {(data?.isPremium && t('projectCard.premium')) ||
                    (data?.isFeatured && t('projectCard.featured'))}
                </span>
              </div>
            )}
            {/* Tag */}
            <ElasticCarousel navigateLink={`/projects/${data?.slug}`} images={data?.images} />

            <div className={classes.socialIconsWrap}>
              <Tooltip text={t('projectCard.tooltips.call')} href={`tel:${phoneNumber}`}>
                <div className={classes.socialIcons}>
                  <MdWifiCalling3 fill="#00A997" size={20} />
                </div>
              </Tooltip>
              <Tooltip text={t('projectCard.tooltips.email')}>
                <div
                  className={classes.socialIcons}
                  onClick={(e) => {
                    e.preventDefault();
                    e?.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                    onEmailClick && onEmailClick();
                  }}>
                  <IoIosMail fill="#00A997" size={22} />
                </div>
              </Tooltip>
            </div>
            <div className={classes.iconWrap}>
              <Tooltip text={t('projectCard.tooltips.compare')}>
                <div className={classes.iconWrapInner}>
                  <BiTransfer
                    onClick={(e) => {
                      e.preventDefault();
                      e?.stopPropagation();
                      e.nativeEvent.stopImmediatePropagation();
                      if (!handleAction()) return;
                      handleCompare(data);
                    }}
                    size={25}
                    fill={`${
                      user?.compareList?.find((item) => item?.entity == data?._id)
                        ? 'var(--action-icon-clr)'
                        : 'white'
                    }`}
                  />
                </div>
              </Tooltip>
              <Tooltip
                text={
                  isFavorite
                    ? t('projectCard.tooltips.removeFavorite')
                    : t('projectCard.tooltips.addFavorite')
                }>
                {isFavorite ? (
                  <div className={classes.iconWrapInner}>
                    <AiFillHeart
                      onClick={(e) => {
                        e.preventDefault();
                        e?.stopPropagation();
                        e.nativeEvent.stopImmediatePropagation();
                        handleFavorite();
                      }}
                      fill="var(--action-icon-clr)"
                      size={25}
                    />
                  </div>
                ) : (
                  <div className={classes.iconWrapInner}>
                    <AiOutlineHeart
                      onClick={(e) => {
                        e.preventDefault();
                        e?.stopPropagation();
                        e.nativeEvent.stopImmediatePropagation();
                        if (!handleAction()) return;
                        handleFavorite();
                      }}
                      fill="white"
                      size={25}
                    />
                  </div>
                )}
              </Tooltip>
            </div>
          </div>
        </div>
        <Link to={`/projects/${data?.slug}`}>
          <div
            className={type === 'map' ? classes.contentWrapMap : classes.contentWrap}
            onClick={() => navigate(`/projects/${data?.slug}`)}>
            <div className={classes.content}>
              <div className={classes.priceRow}>
                <div className={classes.price1}>
                  <p>{data?.title?.[selectedLanguage]}</p>
                </div>
              </div>
              <div className={classes.description}>
                <p>
                  {data?.description?.[selectedLanguage] &&
                    parser(data?.description?.[selectedLanguage])}
                </p>
              </div>

              <div className={classes.addressWrap}>
                <MdLocationOn fill="var(--secondary-clr)" />
                <p className="textOneLine">{data?.address}</p>
              </div>

              {!feature ? (
                <div className={classes.propertyDetailWrap}>
                  <Row className={classes.gap}>
                    <Col md={6} className={classes.propertyDetail}>
                      <Tooltip text={t('projectCard.tooltips.projectType')}>
                        <img src={building} alt="building" />
                        {/* <RiHotelFill color="var(--text-dark-gray-clr)" /> */}
                      </Tooltip>
                      <p>{data?.projectType?.title?.[selectedLanguage]}</p>
                    </Col>
                    <Col md={6} className={classes.propertyDetail}>
                      <Tooltip text={t('projectCard.tooltips.noOfUnits')}>
                        <img src={Area} alt="building" />
                      </Tooltip>
                      <p className="p18">
                        {data?.noOfUnits} {t('projectCard.units')}
                      </p>
                    </Col>
                    {/* <Col md={6} className={classes.propertyDetail}>
                    <Tooltip text={t('projectCard.tooltips.deliveryDate')}>
                      <ReactSVG
                        color="var(--text-dark-gray-clr)"
                        className={classes.svgIcon}
                        src={DateTime}
                      />
                    </Tooltip>
                    <p>{moment(data?.deliveryDate).format('ll')}</p>
                  </Col> */}
                  </Row>
                </div>
              ) : (
                <div className={classes.propertyDetailWrap}>
                  <Row className={classes.gap}>
                    <Col md={6} className={classes.propertyDetail}>
                      <Tooltip text={t('projectCard.tooltips.projectType')}>
                        {/* <RiHotelFill color="var(--text-dark-gray-clr)" /> */}
                        <img src={building} alt="building" />
                      </Tooltip>
                      <p>{data?.projectType?.title?.[selectedLanguage]}</p>
                    </Col>

                    <Col md={6} className={classes.propertyDetail}>
                      <Tooltip text={t('projectCard.tooltips.deliveryDate')}>
                        <TbCalendarTime color="var(--text-dark-gray-clr)" />
                      </Tooltip>
                      <p>{moment(data?.deliveryDate).format('ll')}</p>
                    </Col>
                  </Row>
                </div>
              )}
            </div>
            <div className={type === 'map' ? classes.endDivMap : classes.endDiv}>
              <div
                className={classes.key}
                onClick={(e) => {
                  e.preventDefault();
                  e?.stopPropagation();
                  e.nativeEvent.stopImmediatePropagation();
                  navigate(`/company/${data?.company?.slug}`);
                }}>
                <img src={imageUrl(data?.company?.photo)} />
              </div>
              <p>
                <span className={classes.startingFrom}>{t('projectCard.startingFrom')}</span>
                {usdToOther2({ amount: data?.price, ...currency })}
              </p>
            </div>
          </div>
        </Link>
      </div>
    </>
  );
};

export default ProjectCard;
